import * as Constants from "@app/constants";

export { currentUser } from "@amplio-common/selectors/auth";

export const isAdmin = state => state.auth.user.role === Constants.ROLES.SYSTEM_ADMIN.id;

export const isClinicAdministrator = state => state.auth.user.role === Constants.ROLES.CLINIC_ADMINISTRATOR.id;

export const isTherapist = state => state.auth.user.role === Constants.ROLES.THERAPIST.id;


